<div class="row" *ngIf="widgetType">
  <div class="col-lg-9">
    <div class="row">
      <div class="col-lg-4">
        <div class="form-group input-group-sm">
          <label>Name</label>
          <input type="text" placeholder="name" class="form-control" [(ngModel)]="w.name">
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group input-group-sm">
          <label>Period</label>
          <!--<input type="text" placeholder="period" class="form-control" [(ngModel)]="w.period">-->      
          <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="form-group input-group-sm">
          <label>Refresh (seconds)</label>
          <input type="number" placeholder="name" class="form-control" [(ngModel)]="w.refreshInterval">
        </div>
      </div>
      <div class="col-lg-3">
        <div class="form-group input-group-sm">
          <label>Bearing (degrees)</label>
          <input type="number" placeholder="name" class="form-control" [(ngModel)]="w.bearing">
        </div>
      </div>
      <div class="col-lg-3">
        <div class="form-group input-group-sm">
          <label>View Angle (degrees)</label>
          <input type="number" placeholder="name" class="form-control" [(ngModel)]="w.viewAngle">
        </div>
      </div>
      <div class="col-lg-3">
        <div class="form-group input-group-sm">
          <label>Widget Size</label>
          <select [(ngModel)]="w.size" class="input-group form-select">
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="form-group input-group-sm">
          <label>Aspect Ratio</label>
          <select [(ngModel)]="w.aspectRatio" class="input-group form-select">
            <option value="square">Square</option>
            <option value="16:9">16:9</option>
            <option value="4:3">4:3</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3">
    
        <div class="list-group mt-3">
    
          <div class="list-group-item d-flex align-items-center">
            <div class="flex-fill">
              <div class="fw-bold">Show Meta Data</div>
              <div class="small text text-opacity-50">Show image overlays for AI analysis</div>
            </div>
            <div>
              <div class="form-switch me-n1">
                <input type="checkbox" class="form-check-input" id="customSwitch2" [(ngModel)]="widget.showImageMetaData">
                <label class="form-check-label" for="customSwitch2"></label>
              </div>
            </div>
          </div>

          <div *ngIf="widget.showImageMetaData" class="list-group-item d-flex align-items-center ps-5">
            <div class="flex-fill">
              <div class="fw-bold">Filter Images</div>
              <div class="small text text-opacity-50">Hide images without metadata</div>
            </div>
            <div>
              <div class="form-switch me-n1">
                <input type="checkbox" class="form-check-input" id="customSwitch6" [(ngModel)]="widget.hideImagesWithoutMetaData">
                <label class="form-check-label" for="customSwitch6"></label>
              </div>
            </div>
          </div>
    
          <div class="list-group-item d-flex align-items-center">
            <div class="flex-fill">
              <div class="fw-bold">Show Title</div>
            </div>
            <div>
              <div class="form-switch me-n1">
                <input type="checkbox" class="form-check-input" id="customSwitch4" [(ngModel)]="widget.showTitle">
                <label class="form-check-label" for="customSwitch4"></label>
              </div>
            </div>
          </div>
    
          <div class="list-group-item d-flex align-items-center">
            <div class="flex-fill">
              <div class="fw-bold">Show Time Scroller</div>
            </div>
            <div>
              <div class="form-switch me-n1">
                <input type="checkbox" class="form-check-input" id="customSwitch4" [(ngModel)]="widget.timeScroller">
                <label class="form-check-label" for="customSwitch4"></label>
              </div>
            </div>
          </div>

          <div class="list-group-item d-flex align-items-center">
            <div class="flex-fill">
              <div class="fw-bold">Show Bearing</div>
            </div>
            <div>
              <div class="form-switch me-n1">
                <input type="checkbox" class="form-check-input" id="customSwitch4" [(ngModel)]="widget.showBearing">
                <label class="form-check-label" for="customSwitch4"></label>
              </div>
            </div>
          </div>

          <div class="list-group-item d-flex align-items-center">
            <div class="flex-fill">
              <div class="fw-bold">Enable Live Streaming</div>
            </div>
            <div>
              <div class="form-switch me-n1">
                <input type="checkbox" class="form-check-input" id="customSwitch4" [(ngModel)]="widget.enableLiveStreaming">
                <label class="form-check-label" for="customSwitch4"></label>
              </div>
            </div>
          </div>
    
        </div>
        
      
  </div>
  
  
</div>
<button class="btn btn-outline-theme" *ngIf="w" (click)="addImageFeed()">Add More</button>
<div class="row">
  <div class="col-lg-12">
    <tabset>
      <tab
        *ngFor="let tab of w.timeSeriesList"
        [heading]="tab.uri == null ? 'Not Set' : tab.displayName == '' || tab.displayName == null ? tab.uri : tab.displayName"
        [active]="tab.active"
        (select)="tab.active = true"
        (deselect)="tab.active = false"
        [disabled]="tab.disabled"
        [removable]="true"
        (removed)="removeImageFeed(tab)">
        <div class="row">
          <div class="col-lg-7">
            <div class="row mt-3">
              <div class="col-lg-12">
                <div class="form-group input-group-sm">
                  <label>Select Time Series</label>
                  <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="tab" [enableMediaSearch]="true" [enableTimeSeriesSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
                  <!--<app-time-series-select [timeSeriesDetail]="tab" [enableTagMatch]="true" [type]="'Media'"></app-time-series-select>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab>
    </tabset> 
  </div> 
</div>
